var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.returnGoodsType.length>0)?_c('div',{staticClass:"goods-message",style:(_vm.customStyle)},[_vm._l((_vm.returnGoodsType),function(message){return [_c('p',{class:message.class},[_vm._v(_vm._s(message.content))])]})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }